import type { PortfolioContent } from '../types'
import { resumeContent } from './resume'

export const fallbackContent: PortfolioContent = {
  profile: {
    name: 'Angel Rodriguez',
    role: 'Technology Solutions Consultant',
    headlineLead: 'I shape technology',
    headlineAccent: 'into solutions',
    aboutTitle: 'About me',
    aboutSubtitle: 'Technology & AI Solutions Specialist.',
    bio: [
      resumeContent.professionalSummary,
    ],
    resume: resumeContent,
    closingStatement: 'Let’s build something better.',
    seoDescription: 'Angel Rodriguez | technology solutions consultant.',
  },
  projects: [
    {
      id: 'project-one',
      slug: 'project-one',
      title: 'Twilabeth',
      category: 'AI Business Support Platform',
      year: '2026',
      summary: 'A platform for building AI phone and chat agents powered by OpenAI, featuring company workspaces, built-in API integrations, and seamless deployment across your existing websites and platforms.',
      mediaPath: '/assets/twilabeth-platform.jpg',
      externalUrl: 'https://techculture.twilabeth.workers.dev/',
      order: 1,
      featured: true,
      published: true,
    },
  ],
  experience: [
    { id: 'exp-one', role: 'Your Role', company: 'Your Company', startLabel: '2024', endLabel: 'Present', order: 1, published: true },
    { id: 'exp-two', role: 'Previous Role', company: 'Previous Company', startLabel: '2022', endLabel: '2024', order: 2, published: true },
    { id: 'exp-three', role: 'Earlier Role', company: 'Earlier Company', startLabel: '2020', endLabel: '2022', order: 3, published: true },
  ],
  socialLinks: {
    github: 'https://github.com/Dxniel02',
    linkedin: 'https://www.linkedin.com/in/arodriguez787/',
  },
}
